module.exports = __webpack_public_path__ + "img/gs4.74321394.png";